// import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: '',
  tabs: 'project',
  type: 'project',
  sections: {
    top: [
      // {
      //   id: 'breadcrumbs-project',
      //   type: 'breadcrumbs',
      //   options: {
      //     base: [{
      //       title: 'global#home',
      //       link: '/'
      //     }]
      //   }
      // },
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'tab-bar',
        type: 'tabs',
      },
    ],
    content: [
       {
         id: 'network-resource',
         type: 'network-resource'
       }
    ],
  },
}
// } as ConfigMurucaResourceLayout;
